import { render, staticRenderFns } from "./permissionSet.vue?vue&type=template&id=d35f2ff4&scoped=true&"
import script from "./permissionSet.vue?vue&type=script&lang=js&"
export * from "./permissionSet.vue?vue&type=script&lang=js&"
import style0 from "./permissionSet.vue?vue&type=style&index=0&lang=css&"
import style1 from "./permissionSet.vue?vue&type=style&index=1&id=d35f2ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35f2ff4",
  null
  
)

export default component.exports